import styled from '@emotion/styled';

const StyledFooterMobile = styled.footer(
  {
    '& a': {
      textDecoration: 'none'
    }
  },
  ({ theme }) => ({
    fontSize: theme.typography.fontSize.large
  })
);

export default StyledFooterMobile;
